<template>
  <div class="playlist-mobile-container">
    <!-- 顶部导航栏 -->
    <div class="header-bar">
      <div class="left" @click="$router.go(-1)">
        <i class="el-icon-arrow-left" />
        <span>我的收藏</span>
      </div>
      <div class="right" @click="showCreateDialog = true">
        <i class="el-icon-plus" /> 新建文件夹
      </div>
    </div>

    <!-- 收藏夹列表 -->
    <div v-if="playlist.length > 0" class="playlist-content">
      <div
        v-for="item in playlist"
        :key="item.albumId"
        class="playlist-item-card"
        @click="openAlbumDetail(item)"
      >
        <div class="album-cover">
          <img :src="item.coverUrl" alt="cover">
        </div>
        <div class="album-info">
          <h3 class="album-name">{{ item.albumName }}</h3>
          <p class="album-count">
            <span>{{ item.total || 0 }} 个内容</span>
            <span v-if="item.scopeStr" class="scope-tag">{{ item.scopeStr }}</span>
          </p>
        </div>
        <i class="el-icon-arrow-right arrow" />
      </div>
    </div>

    <!-- 空状态 -->
    <div v-else class="empty-state">
      <i class="el-icon-star-off" />
      <p>还没有创建任何收藏夹~</p>
    </div>

    <!-- 新建收藏夹弹窗 -->
    <el-dialog append-to-body :visible.sync="showCreateDialog" title="新建收藏夹" width="85%" center custom-class="mobile-dialog">
      <el-form :model="albumForm">
        <el-form-item>
          <el-input v-model="albumForm.albumName" placeholder="请输入收藏夹名称..." size="medium" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button size="small" @click="showCreateDialog = false">取消</el-button>
        <el-button size="small" type="primary" @click="onCreateAlbum">确定创建</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getUserAlbumList, createAlbum } from '@/api/vod'

export default {
  name: 'MyFavMobile',
  data() {
    return {
      playlist: [],
      showCreateDialog: false,
      albumForm: {
        albumName: ''
      }
    }
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      const queryParams = {
        userId: this.$store.state.userInfo.userIdStr,
        postType: 2,
        pn: 1
      }
      getUserAlbumList(queryParams).then(resp => {
        if (resp && resp.code === 0 && resp.data) {
          this.playlist = resp.data.list || []
        }
      }).catch(err => {
        console.error(err)
      })
    },
    openAlbumDetail(item) {
      this.$router.push(`/my/fav_item/${item.albumId}`)
    },
    onCreateAlbum() {
      if (!this.albumForm.albumName.trim()) {
        return this.$message.warning('请输入收藏夹名称')
      }
      createAlbum({ albumName: this.albumForm.albumName }).then(resp => {
        if (resp.code === 0) {
          this.$message.success('创建成功')
          this.showCreateDialog = false
          this.albumForm.albumName = ''
          this.getData() // 重新拉取列表
        } else {
          this.$message.warning((resp && resp.msg) || '创建失败')
        }
      }).catch(() => {
        // 降级本地追加
        this.playlist.unshift({
          albumId: Date.now(),
          albumName: this.albumForm.albumName,
          total: 0,
          scopeStr: '公开',
          coverUrl: ''
        })
        this.$message.success('创建成功')
        this.albumForm.albumName = ''
        this.showCreateDialog = false
      })
    }
  }
}
</script>

<style scoped lang="scss">
.playlist-mobile-container {
  min-height: 100vh;
  background-color: #f7f8fa;
  padding-top: 50px;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
}

.header-bar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 50px;
  background-color: #ffffff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 15px;
  z-index: 100;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);

  .left {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 16px;
    font-weight: 500;
    color: #303133;
    cursor: pointer;
    i { font-size: 18px; }
  }

  .right {
    font-size: 13px;
    color: #409eff;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 4px;
  }
}

.playlist-content {
  padding: 12px;

  .playlist-item-card {
    display: flex;
    align-items: center;
    background-color: #ffffff;
    border-radius: 8px;
    padding: 12px;
    margin-bottom: 10px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.03);
    cursor: pointer;

    .album-cover {
      width: 56px;
      height: 56px;
      border-radius: 6px;
      overflow: hidden;
      background-color: #f0f0f0;
      margin-right: 12px;
      flex-shrink: 0;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    .album-info {
      flex: 1;

      .album-name {
        font-size: 14px;
        font-weight: 500;
        color: #303133;
        margin: 0 0 6px 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .album-count {
        font-size: 12px;
        color: #909399;
        margin: 0;
        display: flex;
        align-items: center;
        gap: 8px;

        .scope-tag {
          font-size: 10px;
          color: #fb7299;
          background-color: #fce4ec;
          padding: 1px 5px;
          border-radius: 3px;
        }
      }
    }

    .arrow {
      color: #c0c4cc;
      font-size: 14px;
    }
  }
}

.empty-state {
  text-align: center;
  padding-top: 100px;
  color: #909399;

  i {
    font-size: 48px;
    margin-bottom: 10px;
    color: #dcdfe6;
  }
  p {
    font-size: 14px;
    margin: 0;
  }
}
</style>

<style lang="scss">
.mobile-dialog {
  border-radius: 12px !important;
  max-width: 360px;
}
</style>
